import React, { Component } from "react";
import { Route, Switch, Link, Redirect } from "react-router-dom";
import ReactLoading from "react-loading";
import { getSurveyFromFireStore } from "./Config/config";
import * as Session from "./session";

export class LoadCase extends Component {
  constructor(props) {
    super(props);
    const userEmail = props.match.params.userEmail;
    this.state = {
      session: undefined,
      isLoading: true,
      isLoaded: false
    };
  }

  componentDidMount() {
    const userEmail = this.props.match.params.userEmail;
    this.fetch(userEmail);
  }

  fetch(uuid) {
    /**
     * Performs a http request to retrieve the info for the given caseId
     * After retrieving the data:
     * - It sets the data as the Session.currentSession object
     * - it sets the data as the local state
     * - It set the local state property `sectorId`
     * - It updates the state `isLoading` and `isLoaded` accordingly
     */
    return getSurveyFromFireStore(uuid)
      .then(documentSnapshot => {
        const storeSession = documentSnapshot.data();
        // const foundSession = storeSession !== undefined;
        Session.mergeWith(storeSession);
        return Session.loginAndUpdateSessionRegisteredIfRequired();
      })
      .then(() => {
        console.log(Session.currentSession);
        this.setState({
          isLoading: false,
          isLoaded: true,
          // session: foundSession ? Session.currentSession : undefined
          session: Session.currentSession
        });
      })
      .catch(error => {
        console.error(error);
        this.props.history.push("/register");
      });
  }

  render() {
    const { userEmail } = this.props.match.params;
    return (
      <div>
        {this.state.isLoading && (
          <div className="h-100">
            <LoadingPanel />
          </div>
        )}
        {this.state.isLoaded && this.state.session && (
          <div className="text-center">
            <CasePanel session={this.state.session} />
            <br />
            <br />
            <Link
              to={`/user/${
                this.state.session.contactEmail
              }/section/0/subsection/0`}
              className="btn btn-primary"
            >
              Continuar a preencher
            </Link>
            <br />
            <br />
            <p className="small text-muted text-center">
              Para retomar a última utilização
              <br />
              no ponto em que a deixou
            </p>
          </div>
        )}
        {this.state.isLoaded && !this.state.session && (
          <Redirect to={`/user/${userEmail}/notfound`} />
        )}
      </div>
    );
  }
}

const LoadingPanel = props => (
  <div className="text-center">
    <br />
    <span>A carregar ...</span>
    <br />
    <br />
    <ReactLoading type="spin" color="blue" className="mx-auto" />
  </div>
);

const CasePanel = props => (
  <div className="card mx-auto" style={{ width: "30rem" }}>
    <div className="card-header alert-success">Item encontrado</div>
    <table className="table">
      <tbody>
        <tr>
          <td>Empresa</td>
          <td>{props.session.companyId}</td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{props.session.contactEmail}</td>
        </tr>
        <tr>
          <td>Sector</td>
          <td>{props.session.sectorId}</td>
        </tr>
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./src/LoadCase.jsx